<template>
  <div class="member-card" @click="onCardClick">
    <v-checkbox
      hide-details
      readonly
      :model-value="checked"
    />

    <span>
      <slot />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'AppSubscriptionMembersPickerCard',
  props: {
    modelValue: {
      required: true,
      type: Array as PropType<Array<number>>,
    },
    memberId: {
      required: true,
      type: Number,
    },
  },
  computed: {
    checked() {
      return this.modelValue.includes(this.memberId)
    },
  },
  methods: {
    onCardClick() {
      const newSelection = this.modelValue.includes(this.memberId)
        ? this.modelValue.filter((id) => id !== this.memberId)
        : [...this.modelValue, this.memberId]

      this.$emit('update:modelValue', newSelection)
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.member-card {
  display: flex;
  align-items: center;
  border: get-border('border-secondary');
  @include border-radius('border-radius-2');
  padding: 8px 12px;
  cursor: pointer;
}
</style>
